import { render } from "./SingleCourse.vue?vue&type=template&id=1f6ee620&scoped=true"
import script from "./SingleCourse.vue?vue&type=script&lang=js"
export * from "./SingleCourse.vue?vue&type=script&lang=js"

import "./SingleCourse.vue?vue&type=style&index=0&id=1f6ee620&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6ee620"]])

export default __exports__